export const Basename_url = `${process.env.REACT_APP_BASENAME_URL}`;

export const API_URL = `${process.env.REACT_APP_API_URL}/`;

export const RCP_API_URL = `${process.env.REACT_APP_RCP_API_URL}/`;

export const LOGGED_FROM =
  JSON.parse(localStorage.getItem('userDetail') || '{}')?.loginFrom ?? '';
export const USER_MAIL_ID =
  JSON.parse(localStorage.getItem('userDetail') || '{}')?.userEmail ?? '';
export const USER_TYPE =
  JSON.parse(localStorage.getItem('userDetail') || '{}')?.primaryUserType ?? '';
export const USER_ID =
  JSON.parse(localStorage.getItem('userDetail') || '{}')?.userId ?? '';
export const MOXO_USER_ID =
  JSON.parse(localStorage.getItem('moxoUserId') || '0') ?? '';
const getAppScale = () => {
  const scale = getComputedStyle(document.documentElement)
    .getPropertyValue('--app-scale')
    .trim();

  return parseFloat(scale) || 1;
};
export const APP_SCALE = getAppScale();

export const DESKTOP_BREAKPOINT = 1200;

// user
export const LOGIN_URL = 'user/userLogin'; //1
export const SIGNUP_URL = 'user/onboardingPersonal'; //2
export const SIGNUP_SOLICITOR = 'user/solicitor'; //3
export const FORGOT_PASSWORD = 'user/forgotPassword'; //4
export const OTP_VERIFICATION = 'user/otpValidation'; //5
export const RESET_PASSWORD = 'user/resetPassword'; //6
export const Notification_SettingPopup = 'user/storeNotificationSettings'; //7
export const GET_BINDERID = 'user/getBinderId'; //8
export const AutoLogout = 'user/tokenValidation'; //9
export const BUYER_SOLICITOR = 'user/onboardingSolicitor'; //10
export const GETBUYER_SOLICITOR = '/user/getSolicitorDetails'; //11
export const GETUSER_DETAILS = '/user/getUserDetails'; //12
export const GETBUYER_SOLICITOR_BY_ID = '/user/getSolicitorDetailsByBuyerId'; //13
export const USER_UPDATETASK = 'user/updateTask'; //14
export const USER_STORETASK = 'user/storeTask'; //15
export const REAL_TIME = 'user/realTimeGet'; //16
export const SOLICITOR_REAL_TIME = 'user/solicitorRealTime'; //17
export const BUYER_EDITTASK = 'user/editTask'; //18
export const LOCATIONS_AGENT_API = 'user/getAgentUserPropertyList'; //19
export const GET_PROPERTY_ADDRESS = '/user/getPropertyAddress'; //20
export const PROFILE_SETTING = 'user/editProfile'; //21
export const INSIGHTS = 'user/insights'; //22
export const PROPERTYLIST_COMMON = 'user/propertyList'; //23
export const CHECK_ADDRESS = 'user/checkAddress'; //24

// agent
export const AGENT_DASHBOARD_COUNT = 'agent/agentDashboardCount'; //1
export const PUBLISH_CARD = 'agent/getPropertyList/Publish/0/100'; //2
export const UNPUBLISH_CARD = 'agent/getPropertyList/Unpublish/0/100'; //3
export const ENDED_CARD = 'agent/getPropertyList/Sold/0/100'; //4
export const ARCHIVED_CARD = 'agent/getPropertyList/Archived/0/100'; //5
export const APPRAISAL_CARD = 'agent/getPropertyList/Appraisal/0/100'; //6
export const UPDATE_TIMER = 'agent/updateTimer'; //7
export const ADD_PROPERTY_OWNER = 'agent/addPropertyOwner'; //8
export const ADD_PROPERTY_LEGAL = 'agent/addPropertyLegal'; //9
export const ADD_PROPERTY_DETAILS = 'agent/addPropertyDetails'; //10
export const ADD_PROPERTY_CAMPAIGN = 'agent/addPropertyCampaign'; //11
export const ADD_PROPERTY_MEDIA = 'agent/addPropertyMedia'; //12
export const AGENT_REMINDERSETTINGS = 'agent/storeAgentReminderSettings'; //13
export const GET_PROPERTY_INDIVIDUAL = 'agent/getIndividualProperty'; //14
export const EXPANDED_STATUS = 'agent/expandedStatus'; //15
export const GET_BuyersCard = 'agent/userCardDetails'; //16
export const getUserCardActivity = 'agent/userCardActivity'; //17
export const Get_Venue = 'agent/getPropertyVenue'; //18
export const ADD_INSPECTION = 'agent/addInspectionDetails'; //19
export const getIndividualActivity = 'agent/activity'; //20
export const getDashboardActivity = 'agent/activity/0'; //21
export const ADD_VENUE = 'agent/addPropertyVenue'; //22
export const AGENT_GETQUESTION = 'agent/getAgentQuestion'; //23
export const AGENT_SAVEQUESTION = 'agent/saveAgentQuestion'; //24
export const OWNERCARD_EXPANDEDCENTER = 'agent/ownerCardCenter'; //25
export const PUBLISH_WINNER = 'agent/publishWinner'; //26
export const OFFER_ACTIVITY = 'agent/offerActivity'; //27
export const FORWARD_BUYERACTIONTOVENDOR = 'agent/forwardedBuyerActionToVendor'; //28
export const GetBuyerExpandRight = 'agent/buyerExpandedRight'; //29
export const BUYERCARD_EXPANDEDCENTER = 'agent/buyerExpandedCenter'; //30
export const OWNERCARD_RIGHT = 'agent/ownerCardRight'; //31
export const GET_BUYER_COMMUNICATION = 'agent/getBuyerCommunication'; //32
export const GET_VENDOR_COMMUNICATION = 'agent/getVendorCommunication'; //33
export const PROPERTYLIST_BUYER = 'agent/propertyListBuyer'; //34
export const PROPERTYLIST_OWNER = 'agent/propertyListVendor'; //35
export const GETBUYERMATCH = 'agent/buyerMatching'; //36
export const BUYER_GETAUCTION = 'agent/getPropertyAuction'; //37
export const BUYER_SAVEAUCTION = 'agent/createPropertyAuction'; //38
export const GET_AGENT_MANAGEOFFER = 'agent/manageOffer'; //39
export const CONTRACT_APPROVE = 'agent/contractApprove'; //40
export const REQUEST_DEPOSIT = 'agent/requestDeposit'; //41
export const BUYER_CHECK_IN = 'agent/buyerCheckIn'; //42
export const ADD_BUYERSTAGE2 = 'agent/addBuyertoStageTwo'; //43
export const UPDATE_START_TIME = 'agent/updateStartTime'; //44
export const DELETE_OTHERDOC = 'agent/deleteOtherDocuments/'; //45
export const DELETE_INSPECTION = 'agent/deleteTempInspection/'; //46
export const STORE_SECTION_ORDER = 'agent/storeSectionOrder'; //47
export const GET_SECTION_ORDER = 'agent/getSectionOrder/'; //48
export const SHARE_WINNER = 'agent/shareWinner'; //49
export const GET_BUYERID = 'agent/getUserIdByEmail/'; //50
export const VENDOR_CHECK_IN = 'agent/vendorCheckIn'; //51
export const ADD_PIPELINE_OWNER = 'agent/addPipelineOwner'; //52
export const ADD_PIPELINE_PROPERTY = 'agent/addPipelineProperty'; //53
export const GET_TEMPLATE_TEXT = 'agent/getTemplateText'; //54
export const POST_TEMPLATE_TEXT = 'agent/templateText'; //55
export const AGENT_NOTIFICATION_TO_BUYER = '/agent/notificationToBuyer'; //56
export const PIPELINE_CATEGORY = 'agent/getMultiplePipeline	'; //57
export const PIPELINE_CREATE_CATEGORY = 'agent/pipelineCategory'; //58
export const PIPELINE_PROPERTY_DETAILS = 'agent/getSelectedPipelineCategory'; //59
export const PIPELINE_ADDPROPERTY_MEDIA = 'agent/addPipelinePropertyMedia'; //60
export const PIPELINE_REORDERPROPERTY_CATEGORY =
  'agent/updatePipelinePropertyCategoryId'; //61
export const AGENT_MOVE_TO_Archived = 'agent/moveToArchived'; //62
export const AGENT_DASHBOARD_MOVE_TO_Archived = 'agent/movedToArchivedViewed'; //63
export const BROADCAST_MESSAGE_POPUP = 'agent/msgBroadCast'; //64
export const SOLICITOR_CHECK_IN = 'agent/solicitorCheckIn'; //65
export const BINDER_FOR_CONTRACT = 'agent/binderForABPContract'; //66
export const UPDATE_PIPELINE_ORDER = '/agent/updatePipelineOrder'; //67
export const GET_PROPERTIES_ACTIVITY = '/agent/getPropertiesActivity'; //68
export const GET_SEARCH_SUGGESTIONS = 'agent/searchTool'; //69
export const AGENT_PRIVATE_OFFER = '/agent/privateOffer'; //70
export const AGENT_MANAGE_PRIVATE_OFFER = '/agent/managePrivateOffer'; //71
export const AGENT_FORWARD_PRIVATE_OFFER = '/agent/forwardPrivateOffer'; //72
export const AGENT_WITHDRAW_PRIVATE_OFFER = '/agent/withdrawPrivateOffer'; //73
export const POST_AGENT_BANNER_CLOSE = 'agent/bannerTrigger'; //74
export const POST_AGENT_BANNER_VIEW = 'user/bannerView'; //75
export const GET_APPRAISAL_PREFILL = 'agent/preFillPropertyDetails'; //76
export const ADD_EXISTINGPROPERTY_APPRAISAL = 'agent/preFillApprisalUpdate'; //77
export const DELETE_PIPELINE_OTHERDOC = 'agent/deletePipelineOtherDocuments/'; //78
export const EXCHANGED_CARD = 'agent/getPropertyList/Exchanged/0/100'; //79
export const MOVETO_EXCHANGE = 'agent/updateExchangedStatus'; //80
export const MOVETO_SETTLEMENT = 'agent/updateSettlementStatus'; //81
export const EXTEND_LIST = 'agent/extendList'; //82
export const DEPOSIT_MANAGER = 'agent/depositManager'; //83
export const DEPOSIT_MANAGER_DETAILS = 'agent/getPaymentHistoryDetails'; //84
export const CANCEL_FLOW = 'agent/cancelAction'; //85
export const REFUND_STATUS_AGENT = 'agent/updateRefundStatusAgent'; //86
export const GET_ALL_BANNER_AGENT = 'agent/banner'; //87
export const CONTRACT_FILE_UPLOAD = 'agent/contractFileUpload'; //88
export const SIGN_TEMPLATE = 'agent/sendEsign'; //89
export const INVITE = 'agent/invite'; //90
export const GET_CONTACT = 'agent/getContact/All/0/200'; //91
export const GET_ORGANISATION_LIST = '/agencyNameList '; //92
export const GET_MASTER_NOTIFICATION_SETTINGS =
  'agent/getMasterNotificationSettings'; //93
export const STORE_AGENT_NOTIFICATION_SETTINGS =
  'agent/storeAgentNotificationSettings'; //94

// // buyer
export const GET_PROPERTY_INDIVIDUAL_BUYER = 'buyer/getIndividualProperty'; //1
export const BUYER_INSPECTED_DATA = 'buyer/getPropertyList/Inspected/0/100'; //2
export const BUYER_WATCHLISTING_DATA = 'buyer/getPropertyList/Watching/0/15'; //3
export const BUYER_GETQUESTION = 'buyer/getBuyerQuestion'; //4
export const BUYER_SAVEQUESTION = 'buyer/saveBuyerQuestion'; //5
export const BUYER_ALL_PROPERTY = 'buyer/getPropertyList/AllProperty/0/100'; //6
export const BUYER_SAVEDSEARCH = 'user/buyerSavedSearch'; //7
export const BUYER_GETSAVEDSEARCH = 'user/getBuyerSearch'; //8
export const BUYER_GETINDIVIDUALSEARCH = 'user/getIndividualSearch'; //9
export const BUYER_GETSEARCHPROPERTY = 'user/getSearchProperty'; //10
export const BUYER_UPDATEAUCTION = 'buyer/updatePropertyAuction'; //11
export const BUYER_REQUEST_ESIGN = 'buyer/requestESign'; //12
export const REQUEST_CONTRACT = '/buyer/requestContract'; //13
export const GET_BUYER_MANAGEOFFER = 'buyer/manageOffer'; //14
export const BUYER_REVIEW = 'buyer/getNonSurveyList'; //15
export const BUYER_REQUESTSTAGE2 = 'buyer/requestStageTwo'; //16
export const GET_DEPOSIT = 'buyer/getDeposit/'; //17
export const REQUEST_DEPOSIT_DETAILS = 'buyer/requestDepositDetails'; //18
export const BUYER_AUTO_OFFER = 'buyer/autoOffer'; //19
export const EDIT_AUTO_OFFER = 'buyer/editAutoOffer'; //20
export const DELETE_AUTO_OFFER = 'buyer/deleteAutoOffer'; //21
export const BUYER_OFFERCANCEL = 'buyer/offerCancel'; //22
export const BUYER_MAKE_ARCHIVE = 'buyer/makeArchivedlist'; //23
export const WINNER_VIEWED_BY_BUYER = '/buyer/winnerViewedByBuyer'; //24
export const CREATE_BINDER_WITH_AGENT = '/buyer/createBinderWithAgent'; //25
export const POST_BUYER_BANNER_CLOSE = 'buyer/bannerTrigger'; //26
export const BUYER_ACTION_PRIVATE = '/buyer/buyerActionPrivate'; //27
export const POST_BUYER_BANNER_VIEW = 'user/bannerView'; //28
export const POST_BUYER_PRIVATEOFFER_VIEW = 'buyer/privateOfferView'; //29
export const BUYER_VIEW_DEPOSIT_DETAILS = 'buyer/viewedDepositDetails'; //30
export const BUYER_APPROVE_DEPOSIT = 'buyer/approveDeposit'; //31
export const DELETE_SAVED_SEARCH = 'buyer/deleteSavedSearch'; //32
export const REQUEST_SIGN_TEMPLATE = '/buyer/requestSignTemplateDetails'; //33
export const UPLOAD_BUYER_SIGN = 'signUpload'; //34
export const BUYER_CONTRACT_OF_SALE = 'buyer/confirmContractOfSale'; //35
export const BUYER_UPDATE_RATING = 'buyer/updateRating'; //36
export const BUYER_UPLOAD_APPROVED_CONTRACT = 'buyer/uploadApprovedContract'; //37
export const BUYER_MARKET_PLACE_PROPERTY =
  'buyer/getPropertyList/AllProperty/0/3'; //38

// vendor
export const GET_PROPERTY_INDIVIDUAL_VENDOR = 'vendor/getIndividualProperty'; //1
export const EXPANDED_VENDOR_STATUS = 'vendor/expandedStatus'; //2
export const getIndividualActivityVendor = 'vendor/activity'; //3
export const getDashboardActivityVendor = 'vendor/activity/0'; //4
export const VENDOR_GETQUESTION = 'vendor/getVendorQuestion'; //5
export const VENDOR_SAVEQUESTION = 'vendor/saveVendorQuestion'; //6
export const VENDOR_DASHBOARD_COUNT = 'vendor/vendorDashboardCount'; //7
export const ACTIVE_CARD = 'vendor/getPropertyList/Active/0/100'; //8
export const INACTIVE_CARD = 'vendor/getPropertyList/Inactive/0/100'; //9
export const OFFER_ACTIVITY_VENDOR = 'vendor/offerActivity'; //10
export const GET_VENDOR_MANAGEOFFER = 'vendor/manageOffer'; //11
export const POST_VENDOR_BANNER_CLOSE = 'vendor/bannerTrigger'; //12
export const POST_VENDOR_BANNER_PRIVATE_OFFER = 'vendor/privateOfferView'; //13
export const VENDOR_PRIVATE_OFFER_VIEW = '/vendor/privateOfferView'; //14
export const POST_VENDOR_BANNER_VIEW = 'user/bannerView'; //15
export const SOLD_CARD = 'vendor/getPropertyList/Sold/0/100'; //16
export const UPLOAD_VENDOR_SIGN = 'signUpload'; //17
export const GET_VENDOR_PDF = 'vendor/generatePdf'; //18
export const VENDOR_CONFIRM_SIGNATURE = 'vendor/confirmSignature'; //19
export const VENDOR_REQUEST_SIGN_TEMPLATE =
  '/vendor/requestSignTemplateDetails'; //20
export const VENDOR_CONTRACT_OF_SALE = 'vendor/confirmContractOfSale'; //21

// solicitor
export const GET_SOLICITOR_USERLIST = 'solicitor/getUserList'; //10
export const REQUEST_SOLICITOR_USERLIST = 'solicitor/requestedUserList'; //11
export const CANCELLED_SOLICITOR_USERLIST = 'solicitor/cancelledUserList'; //12
export const STORE_ETA = 'solicitor/storeETA'; //13
export const GET_SOLICITOR_PDF = 'solicitor/generatePdf'; //17
export const SOLICITOR_CONFIRM_SIGNATURE = 'solicitor/confirmSignature'; //18
export const SOLICITOR_CREATE_BINDER_BEFORE_ACCEPT =
  'solicitor/createBinderBeforeAccept'; //19
export const SOLICITOR_CREATE_BINDER = 'solicitor/createBinderSolicitor'; //20
export const SOLICITOR_LINK_TO_BUYER = 'solicitor/linkToBuyer'; //21
export const SOLICITOR_CREATE_BINDER_AFTER_ACCEPT =
  'solicitor/createBindersAfterAccept'; //22
export const SOLICITOR_REVOKE = 'solicitor/revokeUser'; //23
export const SOLICITOR_CREATE_SOL_BUYER_BINDER =
  'solicitor/createSolBuyerBinder'; //24
export const SOLICITOR_STORE_SOLICITOR_COMPANY =
  'solicitor/storeSolicitorCompany'; //25
export const SOLICITOR_GET_SOLICITOR_COMPANY = 'solicitor/getSolicitorCompany'; //26

// others
export const ADD_PROPERTY_TYPELIST = 'propertyTypeList'; //1
export const ADD_PROPERTY_FEATURELIST = 'propertyFeatureList'; //2
export const GET_PROPERTY_LIST = 'property/getPropertyList'; //3
export const ADD_PROPERTY = 'property/addProperty'; //4
export const START_CAMPAIGN = 'property/createCampaign'; //5
export const UPDATE_CAMPAIGN = 'property/updateTimer'; //6
export const STREET_TYPE_LIST = 'streetTypeList'; //7
export const FCM_TOKEN = 'storeTokenFirebase'; //8
export const AUDIO_FILES = 'audioFileList'; //9
export const GET_FILE_MANAGER = 'file/getFilemanager'; //10
export const GET_INDIVIDUAL_FILE_MANAGER = 'file/getIndividualFilemanager'; //11
export const UPLOAD_FILE_MANAGER = 'file/uploadFileManager'; //12
export const DOCUMENT_TYPE_LIST = 'file/documentTypeList'; //13
export const APPROVE_FILE = 'file/approveFiles'; //14

// admin
export const ADMIN_DASHBOARD_SUMMARY = 'admin/dashboardSummary'; //1
export const ADMIN_USER_LIST = 'admin/userList'; //2
export const ADMIN_USER_SEARCH = 'admin/userSearch'; //3
export const ADMIN_LOGIN_ACTIVITY_LIST = 'admin/loginActivityList'; //4
export const ADMIN_LOGIN_ACTIVITY_SEARCH = 'admin/loginActivitySearch'; //5



